export const ELIGIBILITY_LABELS: Record<string, string> = {
  YES: "Yes — I am a woman 18 years or over",
  YES_JUVENILE: "No — I am not 18 years old yet",
  NO: "No — I am not a woman",
};

export const ENGLISH_LEVEL_LABELS: Record<string, string> = {
  A1: "A1 — Beginner",
  A2: "A2 — Elementary",
  B1: "B1 — Intermediate",
  B2: "B2 — Upper intermediate",
  C1: "C1 — Advanced",
  C2: "C2 — Proficient",
};

export const PRIORITY_LABELS: Record<string, string> = {
  work_or_study: "For work or study",
  social_connection: "For social connection",
  everyday_life: "For everyday life",
  travel_and_culture: "For travel and culture",
  general_confidence: "For general speaking confidence",
};

export const CHALLENGE_LABELS: Record<string, string> = {
  no_practice_people: "I don’t have people to practise with",
  shy_or_nervous: "I feel too shy or nervous to speak with anyone",
  not_enough_time: "I don’t have a lot of time",
  no_topics: "I don’t know what to talk about",
  nothing: "Nothing really",
};

export const READINESS_LABELS: Record<string, string> = {
  two_or_three_times: "Yes! At least 2–3 times this week",
  once: "Yes! At least once this week",
  not_this_week: "No, not this week",
};

export function signUpAnswerLabel(
  value: string | null | undefined,
  labels: Record<string, string>,
): string {
  if (!value?.trim()) return "Not recorded";
  return Object.keys(labels).includes(value) ? labels[value] : value;
}

export function formatSignUpSessionTime(
  value: string | null | undefined,
  timezone: string | null | undefined,
): string {
  if (!value) return "Time not recorded";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Time not recorded";
  const options: Intl.DateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "short",
  };
  try {
    const zone = timezone || "UTC";
    return `${new Intl.DateTimeFormat("en-GB", { ...options, timeZone: zone }).format(date)} (${zone})`;
  } catch {
    // Fall back to UTC for unrecognised legacy timezones.
    return `${new Intl.DateTimeFormat("en-GB", { ...options, timeZone: "UTC" }).format(date)} (UTC)`;
  }
}
